import { FreeSpinsSyncFailure } from "@/v2/types/FreeSpinsSync/FreeSpinsSyncResult.interface";

import { FailedGame } from "../types/FreeSpinsRetrieval";

import { byGameCode } from "./byGameCode";

/** One row per game, A to Z. Failures without a game are left out: only the CSV has them. */
export const getFailedGames = (failures: FreeSpinsSyncFailure[]): FailedGame[] => {
  const games = new Map<number, FailedGame>();
  failures.forEach(({ gameId, gameCode }) => {
    if (gameId === undefined || gameCode === undefined || games.has(gameId)) return;
    games.set(gameId, { gameId, gameCode });
  });
  return Array.from(games.values()).sort(byGameCode);
};
